import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentProject } from "../../store/slices/projects";
import {
  selectIsAdmin,
  selectIsProjectAdmin,
  selectSessionStatus,
  SESSION_AUTHENTICATED,
} from "../../store/slices/user";
import {
  loadPermissions,
  selectCan,
  selectPermissionsReady,
} from "../../store/slices/permissions";

/** Keeps the user's permissions in step with the current project (LF360-2024). */
export const usePermissionsSync = () => {
  const dispatch = useDispatch();
  const project = useSelector(selectCurrentProject);
  const session = useSelector(selectSessionStatus);

  useEffect(() => {
    if (session === SESSION_AUTHENTICATED) {
      dispatch(loadPermissions(project?.id || null));
    }
  }, [project?.id, session, dispatch]);
};

/** Whether the user may do any of `keys` in the current project. */
export const useCan = (...keys) =>
  useSelector((state) => selectCan(state, ...keys));

export const usePermissionsReady = () => useSelector(selectPermissionsReady);

const NO_PERMISSIONS = [];

/** Everything the screen rules in common/permissions/screens.js read. */
export const useAccess = () => {
  const isOrgAdmin = useSelector(selectIsAdmin);
  const isProjectAdmin = useSelector(selectIsProjectAdmin);
  const permissions = useSelector(
    (state) => state.permissions?.permissions || NO_PERMISSIONS
  );
  const ready = useSelector(selectPermissionsReady);

  return useMemo(
    () => ({ isOrgAdmin, isProjectAdmin, permissions, ready }),
    [isOrgAdmin, isProjectAdmin, permissions, ready]
  );
};
